export default __webpack_public_path__ + "assets/apple-icon-76x76.35bf1f29c9b847ec0b7cb455cdf09dec.png";